import { createFileRoute } from "@tanstack/react-router";
import { assertPagePermission } from "@/features/auth/lib/assert-page-permission";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { usePageState } from "@/hooks/usePageState";
import {
  publicApiTokensListQueryOptions,
  pageStateQueryOptions,
  PageAccessError,
} from "@/lib/queries";
import { ApiTokensPage } from "@/features/public-api/components/ApiTokensPage";
import { PageError } from "@/features/auth/components/PageError";

export const Route = createFileRoute("/_authenticated/api-tokens")({
  beforeLoad: () => assertPagePermission("public-api"),
  loader: async ({ context }) => {
    const pageState = await context.queryClient
      .ensureQueryData(pageStateQueryOptions("public-api"))
      .catch((err: unknown) => {
        if (err instanceof PageAccessError) return null;
        throw err;
      });

    void context.queryClient.prefetchQuery(publicApiTokensListQueryOptions());

    return pageState;
  },
  component: ApiTokensRoute,
  errorComponent: ({ error }) => (
    <PageError is403={error instanceof PageAccessError} />
  ),
});

function ApiTokensRoute() {
  useDocumentTitle("Public API");
  const { isLoading, error } = usePageState("public-api");

  if (isLoading) {
    return <div className="flex h-full items-center justify-center">Loading…</div>;
  }

  if (error) {
    return <PageError is403={error instanceof PageAccessError} />;
  }

  return <ApiTokensPage />;
}
